<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="题目ID">-->
<!--              <a-input placeholder="请输入题目ID" v-model="queryParam.questionId"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="选项ID">-->
<!--              <a-input placeholder="请输入选项ID" v-model="queryParam.optionsId"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-col :xl="6" :lg="7" :md="8" :sm="24">-->
<!--            <a-form-item label="其他内容">-->
<!--              <a-input placeholder="请输入其他内容" v-model="queryParam.value"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="班级名称">
              <j-search-select-tag
                placeholder="请输入班级名称"
                v-model="queryParam.classId"
                dict="school_class,name,id"
                :async="false"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="老师姓名">
              <j-search-select-tag
                placeholder="请输入老师姓名"
                v-model="queryParam.createBy"
                dict="sys_user,realname,id"
                :async="false"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="学生姓名">
              <j-search-select-tag
                placeholder="请输入学生姓名"
                v-model="queryParam.studentId"
                dict="student_info,name,id"
                :async="false"
                style="width: 100%"
              ></j-search-select-tag>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
<!--              <a @click="handleToggleSearch" style="margin-left: 8px">-->
<!--                {{ toggleSearchStatus ? '收起' : '展开' }}-->
<!--                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>-->
<!--              </a>-->
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
<!--      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>-->
      <a-button :loading="btnLoading" type="primary" icon="download" @click="handleExportXls('学生心理健康动态观测表报表')">一键导出</a-button>
      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">刷新</a-button>

      <!--      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">-->
<!--        <a-button type="primary" icon="import">导入</a-button>-->
<!--      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <evaluationDetail-modal ref="modalForm" @ok="modalFormOk"></evaluationDetail-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import EvaluationDetailModal from './modules/EvaluationDetailModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'


  export default {
    name: "EvaluationDetailList",
    mixins:[JeecgListMixin],
    components: {
      EvaluationDetailModal,
      JSearchSelectTag
    },
    data () {
      return {
        description: '学生心理健康动态观测表报表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
           },
		   {
            title: '班级名称',
            align:"center",
            dataIndex: 'classId_dictText'
           },
          {
            title: '班主任姓名',
            align:"center",
            dataIndex: 'createBy_dictText'
          },
          {
            title: '学生姓名',
            align:"center",
            dataIndex: 'studentId_dictText'
          },
          {
            title: '1.性格特征',
            align:"center",
            dataIndex: 'question1'
          },
          {
            title: '2.情绪特征',
            align:"center",
            dataIndex: 'question2'
          },
          {
            title: '3.近期情绪状态如何',
            align:"center",
            dataIndex: 'question3'
          },
          {
            title: '4.家庭类型',
            align:"center",
            dataIndex: 'question4'
          },
          {
            title: '5.父母教养方式',
            align:"center",
            dataIndex: 'question5'
          },
          {
            title: '6.近期是否发生亲子冲突',
            align:"center",
            dataIndex: 'question6'
          },
          {
            title: '7.近期朋辈关系',
            align:"center",
            dataIndex: 'question7'
          },
          {
            title: '8.近期是否出现人际关系不良',
            align:"center",
            dataIndex: 'question8'
          },
          {
            title: '9.近期学习态度如何',
            align:"center",
            dataIndex: 'question9'
          },
          {
            title: '10.近期学业压力情况',
            align:"center",
            dataIndex: 'question91'
          },
          {
            title: '11.近期是否出现特殊行为',
            align:"center",
            dataIndex: 'question92'
          },
          {
            title: '12.近期睡眠情况',
            align:"center",
            dataIndex: 'question93'
          },
          {
            title: '13.是否出现请假情况',
            align:"center",
            dataIndex: 'question94'
          },
          {
            title: '14.学生在班级成绩排名',
            align:"center",
            dataIndex: 'question95'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' },
          }
        ],
		url: {
          list: "/evaluation/list",
          delete: "/evaluation/delete",
          deleteBatch: "/evaluation/deleteBatch",
          exportXlsUrl: "/evaluation/exportXls",
          importExcelUrl: "/evaluation/importExcel",
       },
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
    methods: {

    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>